var map = {
	"./colis/colis_3.jpg": 3877,
	"./foret/foret_3.jpg": 3099,
	"./genie/genie_3.jpg": 4448,
	"./porte/porte_3.jpg": 3116,
	"./vaisseau/vaisseau_3.jpg": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3981;